export default {
  data () {
    return {
      formRules: { // 表单验证规则
        // 球队全称
        // squadName: [{
        //   required: true,
        //   validator: (rule, value, callback) => {
        //     if (value && value.length <= 50) {
        //       if (this.squadInfo.shortName && value === this.squadInfo.shortName) {
        //         callback(new Error('球队全称不能跟球队简称称一致'))
        //       } else {
        //         callback()
        //       }
        //     } else {
        //       callback(new Error('请输入球队全称(50个字以内)'))
        //     }
        //   },
        //   trigger: 'blur'
        // }],
        squadName: [{
          required: true,
          message: '请选择球队名称',
          trigger: 'change'
        }],
        shortName: [{
          required: true,
          validator: (rule, value, callback) => {
            if (value && value.length <= 20) {
              if (this.squadInfo.squadName && value === this.squadInfo.squadName) {
                callback(new Error('球队简称不能跟球队全称一致'))
              } else {
                callback()
              }
            } else {
              callback(new Error('请输入球队简称(20个字以内)'))
            }
          },
          trigger: 'blur'
        }],
        chiefCoachUuid: [{ required: false, message: '请选择主教练', trigger: 'change' }],
        youthUuid: [{ required: true, message: '请选择单位', trigger: 'change' }],
        organUuid: [{ required: true, message: '请选择管理单位', trigger: 'change' }],
        leaderUuid: [{ required: true, message: '请选择领队', trigger: 'change' }],
        squadSex: [{ required: true, message: '请选择球队人员性别', trigger: 'change' }],
        payToCoachNum: [{ required: true, message: '请选择购买教练员数量', trigger: 'change' }],
        coachRenewList: [{ required: true, message: '请选择开通教练员', trigger: 'change' }],
        renewToCoachLimit: [{ required: true, message: '请选开通费年限', trigger: 'change' }]
      },
      squadNameBusy: false,
      LeaderBusy: false,
      MasterCoachBusy: false
    }
  }
}
